import { render, staticRenderFns } from "./KpTextField.vue?vue&type=template&id=c1f37dfa&scoped=true"
import script from "./KpTextField.vue?vue&type=script&lang=js"
export * from "./KpTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f37dfa",
  null
  
)

export default component.exports